<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout row wrap justify-center>
          <!-- MODULE ADMIN SECTION -->
          <v-flex
            class="py-0 pb-1 pt-0 px-1"
            xs12
            v-if="
              ($store.state.storeAuth.userProfile.isSuperAdmin &&
                $store.state.storeAuth.userProfile.client ==
                  $store.state.storeClient.client.basicSettings.name) ||
              $store.state.storeAuth.userProfile.isSuperStoreAdmin
            "
          >
            <v-card
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray'
                  : 'border-bottom: 1px solid lightgray'
              "
            >
              <v-card-title
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: #505050'
                    : 'background-color: white; border-bottom: 1px solid lightgray'
                "
                :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
                class="title font-weight-regular"
              >
                <v-icon
                  :class="
                    getTheme() == 'dark' ? 'white--text' : 'primary--text'
                  "
                  class="mr-3"
                  medium
                  >mdi-shield-home</v-icon
                >
                {{ $t("dashboardCardSuperAdminTitle") }}
              </v-card-title>
              <v-card-actions
                class="d-flex flex-wrap align-stretch"
                :class="
                  getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: whitesmoke'
                    : 'background-color: white'
                "
              >
                <!-- SETTINGS MODULE PHOTO ORDER -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeClient.client.modules.modulePhotoOrder
                      .active &&
                      $store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                    $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  path="/settingsSubMenuModulePhotoOrder"
                  icon="mdi-image-multiple"
                  badgeIcon="mdi-folder"
                  :title="$t('settingsSubMenuModulePhotoOrderTitle')"
                ></home-menu-admin-btn>
                <!-- SETTINGS MODULE PHOTO GIFT -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeClient.client.modules.modulePhotoGift
                      .active &&
                      $store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                    $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  path="/settingsSubMenuModulePhotoGift"
                  icon="mdi-glass-mug"
                  badgeIcon="mdi-folder"
                  :title="$t('settingsSubMenuModulePhotoGiftTitle')"
                ></home-menu-admin-btn>
                <!-- SETTINGS MODULE GIFT CARD -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeClient.client.modules.moduleGiftCard
                      .active &&
                      $store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                    $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  path="/settingsSubMenuModuleGiftCard"
                  icon="mdi-card-bulleted-outline"
                  badgeIcon="mdi-folder"
                  :title="$t('settingsSubMenuModuleGiftCardTitle')"
                ></home-menu-admin-btn>
                <!-- SETTINGS MODULE USER SETTINGS -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeClient.client.modules.moduleUserSettings
                      .active &&
                      $store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                    $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  path="/settingsSubMenuModuleUserSettings"
                  icon="mdi-shield-account"
                  badgeIcon="mdi-folder"
                  :title="$t('settingsSubMenuModuleUserSettingsTitle')"
                ></home-menu-admin-btn>
                <!-- SETTINGS IMAGE DATABSES -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                    $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  path="/settingsSubMenuImageDatabase"
                  icon="mdi-image-edit"
                  badgeIcon="mdi-database"
                  :title="$t('settingsSubMenuModuleImageDatabasesTitle')"
                ></home-menu-admin-btn>
                <!-- SETTINGS PROMO CODES -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                    $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  path="/settingsPromoCodes"
                  icon="mdi-cart-plus"
                  :title="$t('dashboardCardSuperAdminPromoCodes')"
                ></home-menu-admin-btn>
                <!-- SETTINGS DELIVERY -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                    $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  path="/settingsDelivery"
                  icon="mdi-package-variant"
                  :title="$t('dashboardCardSuperAdminDelivery')"
                ></home-menu-admin-btn>
                <!-- SETTINGS USER RIGHTS -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                    $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  path="/settingsUserRights"
                  icon="mdi-shield-check"
                  :title="$t('dashboardCardSuperAdminUserRights')"
                ></home-menu-admin-btn>
                <!-- SETTINGS COLORS -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                    $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  path="/settingsColors"
                  icon="mdi-palette"
                  :title="$t('dashboardCardSuperAdminColors')"
                ></home-menu-admin-btn>
                <!-- SETTINGS OTHER -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                    $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  path="/settingsOther"
                  icon="mdi-settings"
                  :title="$t('dashboardCardSuperAdminOther')"
                ></home-menu-admin-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'home' })"
          ></simple-navigation-button>
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import HomeMenuAdminBtn from "@/components/HomeMenuAdminBtn";

export default {
  name: "settingsSubMenu",
  components: {
    AppNavigation,
    SimpleNavigationButton,
    HomeMenuAdminBtn,
  },
};
</script>
<style scoped>
.item {
  margin: 5px;
  padding: 5px;
  width: 100px;
  text-align: center;
}
</style>
